import {FITHGameConfig} from "../FITHGameConfig";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {ParticlesManager} from "@nolimitcity/slot-game/bin/core/particles/ParticlesManager";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {AnimatedParticle, Emitter} from "pixi-particles";
import {TweenLite} from "gsap";
import {FITHGameModuleConfig} from "../FITHGameModuleConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";

require("pixi-particles");

export class CoinsFountain extends BaseView {
    private readonly _centre: number = FITHGameConfig.instance.REEL_AREA_WIDTH / 2;

    private readonly _smokeConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 0.36
            },
            "scale": {
                "start": 2.5,
                "end": 1.5,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffc859",
                "end": "#ff0000"
            },
            "speed": {
                "start": 700,
                "end": 200,
                "minimumSpeedMultiplier": 1.1
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 0,
                "max": 360
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 0,
                "max": 200
            },
            "lifetime": {
                "min": 0.6,
                "max": 0.9
            },
            "blendMode": "screen",
            "ease": [
                {
                    "s": 0,
                    "cp": 0.329,
                    "e": 0.548
                },
                {
                    "s": 0.548,
                    "cp": 0.767,
                    "e": 0.876
                },
                {
                    "s": 0.876,
                    "cp": 0.985,
                    "e": 1
                }
            ],
            "frequency": 0.001,
            "emitterLifetime": 0.7,
            "maxParticles": 150,
            "pos": {
                "x": this._centre,
                "y": this._centre
            },
            "addAtBack": false,
            "spawnType": "ring",
            "spawnCircle": {
                "x": 0,
                "y": 0,
                "r": 100,
                "minR": 50
            }
        }
    ];
    private _smokeEmitters: Emitter[];
    private _wildMultiplierContainer: PIXI.Container;
    private readonly _wildMultiplierConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 0
            },
            "scale": {
                "start": 0.5,
                "end": 0.01,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffd138",
                "end": "#ff3d3d"
            },
            "speed": {
                "start": 100,
                "end": 150,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": 0
            },
            "maxSpeed": 0,
            "startRotation": {
                "min": 0,
                "max": 360
            },
            "noRotation": false,
            "rotationSpeed": {
                "min": 0,
                "max": 0
            },
            "lifetime": {
                "min": 0.1,
                "max": 0.5
            },
            "blendMode": "screen",
            "frequency": 0.001,
            "emitterLifetime": -1,
            "maxParticles": 700,
            "pos": {
                "x": 0,
                "y": 0
            },
            "addAtBack": false,
            "spawnType": "point"
        }
    ];

    private readonly _screenHeightRange: [number, number] = [720, 1760];
    private readonly _startSpeedRange: [number, number] = [650, 950];
    private _initMaxParticles: number = 150;
    private readonly _coinsConfigs: any[] = [
        {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 280,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": FITHGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 320,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": FITHGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.1,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 380,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 0.1,
            "emitterLifetime": -1,
            "maxParticles": this._initMaxParticles,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": FITHGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        },
        {
            "alpha": {
                "start": 1,
                "end": 0.4
            },
            "scale": {
                "start": 0.7,
                "end": 0.5,
                "minimumScaleMultiplier": 1
            },
            "color": {
                "start": "#ffffff",
                "end": "#ffffff"
            },
            "speed": {
                "start": 10,
                "end": 20,
                "minimumSpeedMultiplier": 1
            },
            "acceleration": {
                "x": 0,
                "y": -50
            },
            "maxSpeed": 420,
            "startRotation": {
                "min": 280,
                "max": 255
            },
            "noRotation": true,
            "rotationSpeed": {
                "min": 5,
                "max": 5
            },
            "lifetime": {
                "min": 0.5,
                "max": 1
            },
            "blendMode": "add",
            "frequency": 2,
            "emitterLifetime": -1,
            "maxParticles": 10,
            "pos": {
                "x": 0,
                "y": 0,
            },
            "addAtBack": false,
            "spawnType": "rect",
            "spawnRect": {
                "x": 0,
                "y": 0,
                "w": FITHGameConfig.instance.GAME_WIDTH - 40,
                "h": 1
            }
        }
    ];
    private _coinsEmitters: Emitter[] = [];
    private _layer: ScalableLayer;
    private _isPlaying: boolean = false;

    /**
     * @description To start the fountain.
     */
    public startFountain(): void {
        if (!this._isPlaying) {
            this._coinsEmitters.forEach(value => value.emit = true);
            this._isPlaying = true;
        } else {
            this._coinsEmitters.forEach(value => {
                value.maxLifetime = value.maxLifetime + 0.2;
                value.minLifetime = value.minLifetime + 0.2;
            });
        }
    }

    /**
     * @description To start the smoke.
     */
    public startSmoke(): void {
        this._smokeEmitters.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
    }

    /**
     * @description To stop the fountain.
     */
    public stopFountain(): void {
        this._coinsEmitters.forEach(value => {
            value.emit = false;
            value.maxParticles = this._initMaxParticles;
            value.maxLifetime = 1;
            value.minLifetime = 0.5;
        });
    }

    /**
     * @description To stop the smoke.
     */
    public stopSmoke(): void {
        this._smokeEmitters.forEach((emitter: Emitter) => {
            emitter.emit = false;
        });
    }

    public startWildMultiplierFountain(from: number[], multiplier: number): void {
        const emitters: Emitter[] = [],
            container: PIXI.Container = new PIXI.Container();

        this.crateWildMultiplierFountain(container, emitters);

        TweenLite.fromTo(container, 0.5, {x: from[0], y: from[1]},
            {
                x: ((FITHGameConfig.instance.REEL_AREA_POS_X + FITHGameConfig.instance.REEL_AREA_WIDTH) - 60), y: 115,
                onComplete: () => {
                    this.stopWildMultiplierFountain(container, emitters);
                    FITHGameModuleConfig.wildMultiplierView.updateMultiplierItem(multiplier, false);
                }
            });

        emitters.forEach((emitter: Emitter) => {
            emitter.emit = true;
        });
    }

    /**
     * @inheritDoc
     */
    protected initAnimations(): void {
        super.initAnimations && super.initAnimations();

        let smokeContainer: PIXI.Container = new PIXI.Container();
        StageManager.getLayer(FITHGameConfig.instance.LAYERS.BIG_WIN_SMOKE.name).addChild(smokeContainer);

        this._smokeEmitters = [];
        this._smokeConfigs.forEach((config: any) => {
            const emitterContainer: PIXI.Container = new PIXI.Container();
            smokeContainer.addChild(emitterContainer);
            const emitter: Emitter = new Emitter(emitterContainer, [{
                framerate: 30,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures("bigWinSmoke")
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._smokeEmitters.push(emitter);
        });

        this._layer = StageManager.getLayer(FITHGameConfig.instance.LAYERS.BIG_WIN_FOUNTAIN.name);

        this._coinsEmitters = [];
        this._coinsConfigs.forEach((value, index: number) => {
            const emitter: Emitter = new Emitter(this._layer, [{
                framerate: 30,
                hasLoaded: true,
                textures: [(GameResources.getTextures(`bigWinFireParticle${index + 1}`)[0])]
            }], this._coinsConfigs[0]);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            this._coinsEmitters.push(emitter);
        });

        this._wildMultiplierContainer = new PIXI.Container();
        StageManager.getLayer(FITHGameConfig.instance.LAYERS.WILD_EXPLODE_SPARKLE.name).addChild(this._wildMultiplierContainer);
    }

    protected onResize(resizeData: IResizeData): void {
        this._layer.position.set(NolimitApplication.screenBounds.left, NolimitApplication.screenBounds.top);

        let screenHeight: number = Math.round(resizeData.height / this._layer.scale.y);
        screenHeight = Math.max(this._screenHeightRange[0], Math.min(screenHeight, this._screenHeightRange[1]));
        const startSpeed: number = Math.round((screenHeight - this._screenHeightRange[0]) * (this._startSpeedRange[1] - this._startSpeedRange[0]) / (this._screenHeightRange[1] - this._screenHeightRange[0]) + this._startSpeedRange[0]);

        const levelSpeed: number = startSpeed * (2);
        this._coinsEmitters.forEach((value, index) => {
            value.startSpeed.value = levelSpeed + (1 + 0.05);
            value.spawnPos.y = this._resizeData.height;
            value.spawnRect.width = this._resizeData.width;
        });
    }

    private crateWildMultiplierFountain(container: PIXI.Container, emitters: Emitter[]): void {
        this._wildMultiplierContainer.addChild(container);
        this._wildMultiplierConfigs.forEach((config: any) => {
            const emitterContainer: PIXI.Container = new PIXI.Container();
            container.addChild(emitterContainer);
            const emitter: Emitter = new Emitter(emitterContainer, [{
                framerate: 30,
                loop: true,
                hasLoaded: true,
                textures: GameResources.getTextures("starA")
            }], config);
            emitter.particleConstructor = AnimatedParticle;
            ParticlesManager.addEmitter(emitter, false);
            emitters.push(emitter);
        });
    }

    private stopWildMultiplierFountain(container: PIXI.Container, emitters: Emitter[]): void {
        emitters.forEach((emitter: Emitter) => {
            emitter.emit = false;
        });

        this._wildMultiplierContainer.removeChild(container);
        container.destroy();
    }
}